import { TimeZones } from 'generated/graphql-types';

export interface AccountLocationView {
   name: string | null;
   locationId: number;
   houseNumber: string | null;
   directionalPrefix: string | null;
   streetName: string | null;
   streetNameSuffix: string | null;
   directionalPostfix: string | null;
   timeZoneId: TimeZones | null;
   comment: string | null;
}

export function areLocationsEqual(a: AccountLocationView, b: AccountLocationView): boolean {
   return (
      a.name === b.name &&
      a.locationId === b.locationId &&
      a.houseNumber === b.houseNumber &&
      a.directionalPrefix === b.directionalPrefix &&
      a.streetName === b.streetName &&
      a.streetNameSuffix === b.streetNameSuffix &&
      a.directionalPostfix === b.directionalPostfix &&
      a.timeZoneId === b.timeZoneId &&
      a.comment === b.comment
   );
}
